// extracted by mini-css-extract-plugin
export default {"ConfirmationPanel":"VFPLM5pHVntZneND-zUyGA=="};